// extracted by mini-css-extract-plugin
module.exports = {"dataColumn":"_8b988bb","dataRow":"_e8e48d9","dataContainer":"_d4e8dd4"};